export interface IProduct {
  id?: number;
  uuid?: string;
  name: string
  description: string
  measurement_unit_id?: any;
  
}


export const productInitValues: IProduct = {
  //id: 0,
  name: '',
  description: '',
}

